export const order_bumps_form_key = "order-bumps";

export const default_listing_quantity = 1;
